export default {
  title: 'SMS panel',

  labels: {
    provider: 'Provider',
    farazsms: 'Fraz SMS',
    smsglobal: 'SMS Global',
    farazsmsUsername: 'Fraz SMS Username',
    farazsmsPassword: 'Fraz SMS Password',
    farazsmsSender: 'Fraz SMS Sender',
    smsglobalUsername: 'SMS Global Username',
    smsglobalPassword: 'SMS Global Password',
    smsglobalSender: 'SMS Global Sender',
    messangerKey: 'Authentication code',
    templates: 'Templates',
    login: 'Login SMS template',
    signup: 'Register SMS template',
    confirmInfo: 'Verify SMS template'
  },

  notifications: {
    edit: {
      success: 'The SMS panel information of the company has been successfully updated'
    }
  },

  invalidTexts: {
    onlyEnglish: 'Only English characters are allowed!'
  }
}
